<section class="py-8 sm:py-14 bg-white border-y border-slate-100 relative hidden lg:block">
    <div
        class="pointer-events-none absolute top-24 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full bg-indigo-200/20 blur-[110px]">
    </div>
    <div class="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div class="">
            <div class="max-w-2xl mx-auto text-center"><span
                    class="inline-block text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 mb-3">Why
                    BeExpert</span>
                <h2 class="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
                    Everything you need to <span class="brand-gradient-text">get hired</span></h2>
                <p class="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">One intelligent platform to build
                    your resume, prepare with AI, apply for jobs, and confidently land your dream career.</p>
            </div>
        </div>
        <div class="mt-14 grid grid-cols-1 md:grid-cols-12 gap-4">
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-6"
                data-testid="why-card-0">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-video w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="m22 8-6 4 6 4V8Z"></path>
                            <rect height="12" rx="2" ry="2" width="14" x="2" y="6"></rect>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900"> AI Video Mock Interviews
                    </h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Practice with realistic AI-powered video
                        interviews and receive instant, personalized feedback to improve every response.</p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-3"
                data-testid="why-card-1">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-clipboard-list w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <rect height="4" rx="1" ry="1" width="8" x="8" y="2"></rect>
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                            <path d="M12 11h4"></path>
                            <path d="M12 16h4"></path>
                            <path d="M8 11h.01"></path>
                            <path d="M8 16h.01"></path>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900"> Industry-Level Mock Tests</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Sharpen your technical and aptitude skills
                        with mock tests designed to match real company hiring patterns.</p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-3"
                data-testid="why-card-2">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-file-text w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900">ATS Resume Builder</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Create a professional, ATS-optimized resume
                        with beautiful templates and real-time ATS score improvements—all in one place.</p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-4"
                data-testid="why-card-3">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-map w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z">
                            </path>
                            <path d="M15 5.764v15"></path>
                            <path d="M9 3.236v15"></path>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900">Personalized Career Roadmap</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Follow a customized learning path with
                        recommended skills, certifications, and practice plans tailored to your career goals.</p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-4"
                data-testid="why-card-4">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-target w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="6"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900"> Placement Readiness Score</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Measure your interview, assessment, and
                        resume performance with a comprehensive readiness score that shows how prepared you are for
                        placements.</p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-4"
                data-testid="why-card-5">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-mouse-pointer-click w-5 h-5" fill="none"
                            height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 4.1 12 6"></path>
                            <path d="m5.1 8-2.9-.8"></path>
                            <path d="m6 12-1.9 2"></path>
                            <path d="M7.2 2.2 8 5.1"></path>
                            <path
                                d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z">
                            </path>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900"> Smart Job Discovery</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Explore job opportunities tailored to your
                        skills, experience, interests, and career goals.
                    </p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-3"
                data-testid="why-card-6">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-video w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path>
                            <rect height="12" rx="2" width="14" x="2" y="6"></rect>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900"> One-Click Job Applications</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Apply to multiple relevant jobs
                        effortlessly
                        without filling out repetitive application forms.</p>
                </div>
            </div>
            <div class="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-4 premium-shadow transition-shadow duration-300 hover:hover-shadow md:col-span-9"
                data-testid="why-card-7">
                <div
                    class="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl">
                </div>
                <div class="relative">
                    <div
                        class="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white shadow-[0_8px_20px_rgba(79,70,229,0.3)] transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                        <svg aria-hidden="true" class="lucide lucide-scan-line w-5 h-5" fill="none" height="24"
                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
                            <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
                            <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
                            <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
                            <path d="M7 12h10"></path>
                        </svg>
                    </div>
                    <h3 class="mt-2.5 font-display font-bold text-lg text-slate-900"> Placement Readiness Score</h3>
                    <p class="mt-1 text-sm text-slate-600 leading-relaxed">Measure your overall job readiness with an
                        intelligent score and receive a personalized action plan to increase your chances of getting
                        hired.</p>
                </div>
            </div>
        </div>
    </div>
</section>